module.exports = __webpack_public_path__ + "static/img/cont17.55ef7c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont17.jpg
// module id = kSjB
// module chunks = 0